import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actionFileUpload, actionFileDownload } from '../module/component/FileAttachModule';
import PopupRef from './PopupRef';

const MultiFileAttachBox = ({ className, uploadFileHandler, files = [], editable, erasable, fileDeleteHandler }) => {
    // useRef를 이용해 input태그에 접근한다.
    const fileUploadInput = useRef();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const KB = 1000;
    const MB = 1000 * KB;
    const maxFileSize = 10 * MB;

    const downloadFileHandler = (e, fileUid) => {
        if (e.target.tagName == 'A') {
            dispatch(
                actionFileDownload({
                    params: {
                        fileUid: fileUid,
                        fileNm: e.target.childNodes[0].textContent,
                    },
                    downloadType: '',
                }),
            );
        }
    };

    const _fileDeleteHandler = (e) => {
        if (e.target.tagName == 'BUTTON') {
            files = files.filter((el) => el.fileUid != e.target.id);
            fileDeleteHandler(files);
        }
    };

    const _uploadFileHandler = (e) => {
        if (files.length >= 5) {
            popupRef.current.openAlert('파일 첨부는 최대 5개까지만 가능합니다.');
        }

        if (e.target.files[0]) {
            const [file] = e.target.files;

            if (file.size > maxFileSize) {
                popupRef.current.openAlert(
                    '파일의 크기가 너무 큽니다. 10MB 이하 파일만 업로드 가능합니다. 파일크기 : ' +
                        file.size / MB +
                        'MB',
                );
            } else {
                dispatch(
                    actionFileUpload({
                        params: {
                            file,
                        },
                        callback: (result) => {
                            uploadFileHandler(result);
                        },
                    }),
                );
            }
        }
    };

    const fileList = files.map((el) => (
        <li className='file-items' key={el.fileUid} onClick={(e, fileUid) => downloadFileHandler(e, el.fileUid)}>
            <a href='#none;'>
                {el.fileNm}
                {erasable && (
                    <button
                        type='button'
                        id={el.fileUid}
                        className='btn sm-del'
                        onClick={(e) => _fileDeleteHandler(e)}
                    ></button>
                )}
            </a>
        </li>
    ));

    return (
        <>
            <div className={className}>
                <div className='file-box-tit'>
                    첨부파일{' '}
                    <input
                        type='file'
                        id='input-file'
                        style={{ display: 'none' }}
                        multiple='multiple'
                        ref={fileUploadInput}
                        onChange={(e) => _uploadFileHandler(e)}
                    />
                    {editable && (
                        <button type='button' className='btn item-add' onClick={(e) => fileUploadInput.current.click()}>
                            첨부파일
                        </button>
                    )}
                </div>
                <div className='post-file-box'>
                    <ul className='file-list'>{fileList}</ul>
                </div>
                <div className='post-file-comment'>첨부파일은 파일당 10MB 이하로 최대 5개까지 첨부 가능합니다.</div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default MultiFileAttachBox;
